import script from "./MainVIPSegView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainVIPSegView.vue?vue&type=script&setup=true&lang=ts"

import "./MainVIPSegView.vue?vue&type=style&index=0&id=1f200c4d&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f200c4d"]])

export default __exports__